import { useTranslation } from 'react-i18next'
import { Base } from '@itsrever/design-system'

const { Textarea } = Base

interface IncidentTextBoxProps {
  description: string
  onDescriptionChange: (value: string) => void
  showValidationError: boolean
}

const IncidentTextBox: React.FC<IncidentTextBoxProps> = ({
  description,
  onDescriptionChange,
  showValidationError
}) => {
  const { t } = useTranslation()
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onDescriptionChange(e.target.value)
  }

  return (
    <div className="flex flex-col gap-1 pb-4 pt-2">
      <Textarea
        id="incident-description"
        name="incident-description"
        value={description}
        onChange={handleChange}
        className="resize-none font-sans"
        rows={3}
        aria-invalid={showValidationError}
        aria-describedby={
          showValidationError ? 'incident-description-error' : undefined
        }
        placeholder={t(
          'process_details_page.report_incident.textbox_placeholder'
        )}
      />
      {showValidationError && (
        <span
          id="incident-description-error"
          className="pl-1 text-xs leading-none text-red-500"
        >
          {t('process_details_page.report_incident.validation_error')}
        </span>
      )}
    </div>
  )
}

export default IncidentTextBox
